export default __webpack_public_path__ + "static/media/pastis.5dc5e020.jpg";